import create from "zustand";

const useUserProfileStore = create((set) => ({
    userDoc: {},
    // setUserDoc: (userDoc) => set((state) => ({ ...state, userDoc })),
    setUserDoc: (userDoc) => set({ userDoc }),
    admin: false,
    setAdmin: (admin) => set({ admin }),
    role: null,
    setRole: (role) => set({ role }),
    clearAccess: () => set({ admin: false, role: null }),
}));

export default useUserProfileStore;
